import { render, staticRenderFns } from "./PendingFbaOrdersPage.vue?vue&type=template&id=7f19a42c&scoped=true"
import script from "./PendingFbaOrdersPage.vue?vue&type=script&lang=js"
export * from "./PendingFbaOrdersPage.vue?vue&type=script&lang=js"
import style0 from "./PendingFbaOrdersPage.vue?vue&type=style&index=0&id=7f19a42c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f19a42c",
  null
  
)

export default component.exports